const EU_MEMBERS = [
  "AT",
  "BE",
  "BG",
  "CY",
  "CZ",
  "DE",
  "DK",
  "EE",
  "ES",
  "FI",
  "FR",
  "GR",
  "HR",
  "HU",
  "IT",
  "LV",
  "LT",
  "LU",
  "IE",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SI",
  "SK",
  "SE",
];

export const isEUMember = (countryCode: string): boolean => {
  return EU_MEMBERS.includes(countryCode.toUpperCase());
};
